import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { BACKEND_URL } from "../lib/api";

export default function PublicBio() {
  const { slug } = useParams();
  const [bio, setBio] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    axios.get(`${BACKEND_URL}/api/public/bio/${slug}`).then((r) => setBio(r.data)).catch(() => setError(true));
  }, [slug]);

  const click = (i, url) => {
    axios.post(`${BACKEND_URL}/api/public/bio/${slug}/click/${i}`).catch(() => {});
    window.open(url.startsWith("http") ? url : `https://${url}`, "_blank");
  };

  if (error) return <div className="min-h-screen flex items-center justify-center text-sm text-slate-400">This page isn't available.</div>;
  if (!bio) return null;
  const bg = bio.brand_colors?.[2] || "#F7F7F9";
  const accent = bio.color;

  return (
    <div className="min-h-screen flex flex-col items-center px-6 py-16" style={{ background: bg }} data-testid="public-bio-page">
      <span className="w-16 h-16 rounded-2xl shadow-lg" style={{ background: accent }} />
      <h1 className="font-display font-bold text-2xl tracking-tight mt-5 text-slate-900">{bio.client_name}</h1>
      {bio.headline && <p className="text-sm text-slate-600 mt-1 text-center max-w-xs">{bio.headline}</p>}
      <div className="w-full max-w-sm mt-8 space-y-3">
        {bio.links.filter((l) => l.title && l.url).map((l, i) => (
          <button key={i} data-testid={`public-bio-link-${i}`} onClick={() => click(i, l.url)}
            className="w-full bg-white border border-black/5 rounded-2xl py-3.5 px-5 text-[14px] font-semibold text-slate-800 shadow-sm hover-lift text-center">
            {l.title}
          </button>
        ))}
      </div>
    </div>
  );
}
